import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService, ErrorStateService } from '@fgb/core';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'fgb-maintenance-page',
  templateUrl: './maintenance-page.component.html',
  styleUrls: ['./maintenance-page.component.scss'],
})
export class MaintenancePageComponent implements OnInit {
  showAppleLink = true;
  showGoogleLink = true;

  constructor(
    private router: Router,
    public errorService: ErrorStateService,
    private authService: AuthService,
    public deviceDetector: DeviceDetectorService
  ) {
    this.authService.checkApiStatus();

    if (this.authService.hasCurrentRefreshToken()) {
      this.router.navigate(['/']);
    }
  }

  ngOnInit() {
    this.downloadAppLink();
  }

  downloadAppLink() {
    if (this.deviceDetector.os.match('iOS')) {
      this.showGoogleLink = false;
    } else if (this.deviceDetector.os.match('Android')) {
      this.showAppleLink = false;
    }
  }
}
